<template>
    <div id="login">
        <div id="login-area" class="my-3 border container">
            <img src="@/assets/oscar_logo_r.png" alt="Oscar">
            <form class="my-4">
                <div class="form-group">
                    <label for="exampleInputEmail1" class="sr-only">{{ $t("user.email") | capitalize-first }}</label>
                    <input v-model="username" class="form-control m-auto" type="text" value="" :placeholder="$t('user.email') | capitalize-first" required>
                </div>
                <div class="form-group">
                    <label for="exampleInputEmail1" class="sr-only">{{ $t("user.password") | capitalize-first }}</label>
                    <input v-model="password" class="form-control m-auto" type="password" value="" :placeholder="$t('user.password') | capitalize-first" required>
                </div>

                <div v-if="showLoginError" class="alert alert-danger">
                    <font-awesome-icon icon="exclamation-triangle" /> {{ $t("loginFailed") }}
                </div>

                <button @click.prevent="login" class="btn btn-primary">{{ $t("login") | capitalize-first }}</button>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Manager',
  data () {
    return {
      username: '',
      password: '',
      showLoginError: false
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    }
  },
  methods: {
    login () {
      let me = this
      axios.post(me.$store.getters.urlPath + 'services/login.php', {
        username: me.username,
        password: me.password
      })
        .then((response) => {
          if (response.data.loggedIn) {
            me.$store.dispatch('setUser', response.data)
            me.$router.push({ name: 'manager' })
          } else {
            me.username = ''
            me.password = ''
            me.showLoginError = true
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
        })
    }
  },
  created () {
    this.$store.dispatch('setTheme', {
      headerBgColor: '#1a1c28',
      headerFontColor: 'white'
    })
  }
}
</script>

<style lang="scss" scoped>
#login {
    height: 100vh;
    background-image: url('~@/assets/bg.jpg');
    padding: 5%;

    #login-area {
        padding: 60px;
        background-color: rgba(255,255,255,0.7);
        border-radius: 0;
        text-align: center;
        box-shadow: 0 0 10px rgba(0,0,0,0.5);
    }

    .form-control {
        max-width: 400px;
    }
}
</style>
